import firebase from 'firebase'
import firestore from 'firebase/firestore'
// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyAVbz7U-KqIFqD1CwJstQiu-QoEtm9akq4",
    authDomain: "udemy-ninja-smoothies-ec829.firebaseapp.com",
    databaseURL: "https://udemy-ninja-smoothies-ec829.firebaseio.com",
    projectId: "udemy-ninja-smoothies-ec829",
    storageBucket: "udemy-ninja-smoothies-ec829.appspot.com",
    messagingSenderId: "288747066698",
    appId: "1:288747066698:web:7b42945ba47e0d481c5db3",
    measurementId: "G-L92VY36B9D"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig)
// firebaseApp.firestore().settings({ timestampsInSnapshots: true })

//export firestore database
export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js